import alert from './alert.svg?raw';
import arrowLeft from './arrowLeft.svg?raw';
import arrowOut from './arrowOut.svg?raw';
import basket from './basket.svg?raw';
import blocks from './blocks.svg?raw';
import burger from './burger.svg?raw';
import calendar from './calendar.svg?raw';
import check from './check.svg?raw';
import checkFilled from './checkFilled.svg?raw';
import checkmark from './checkmark.svg?raw';
import chevronDown from './chevronDown.svg?raw';
import close from './close.svg?raw';
import conditionsMonitoring from './conditionsMonitoring.svg?raw';
import copy from './copy.svg?raw';
import download from './download.svg?raw';
import edit from './edit.svg?raw';
import filters from './filters.svg?raw';
import globe from './globe.svg?raw';
import group from './group.svg?raw';
import info from './info.svg?raw';
import installation from './installation.svg?raw';
import linkedin from './linkedin.svg?raw';
import locator from './locator.svg?raw';
import logout from './logout.svg?raw';
import mail from './mail.svg?raw';
import maintenance from './maintenance.svg?raw';
import minus from './minus.svg?raw';
import more from './more.svg?raw';
import oilFuelAnalysis from './oilFuelAnalysis.svg?raw';
import pencil from './pencil.svg?raw';
import plus from './plus.svg?raw';
import progressArrow from './progressArrow.svg?raw';
import projectBasedService from './projectBasedService.svg?raw';
import rental from './rental.svg?raw';
import search from './search.svg?raw';
import swap from './swap.svg?raw';
import trash from './trash.svg?raw';

export const icons = {
	alert,
	arrowLeft,
	arrowOut,
	basket,
	blocks,
	burger,
	calendar,
	check,
	checkFilled,
	checkmark,
	chevronDown,
	close,
	copy,
	edit,
	filters,
	globe,
	group,
	info,
	locator,
	logout,
	minus,
	more,
	plus,
	progressArrow,
	search,
	swap,
	trash,
	pencil,
	download,
	installation,
	rental,
	maintenance,
	projectBasedService,
	oilFuelAnalysis,
	conditionsMonitoring,
	linkedin,
	mail,
} as const;
